"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typeahead = exports.makeItem = void 0;
var react_1 = __importDefault(require("react"));
var Dropdown_1 = require("./Dropdown");
var Input_1 = require("./Input");
function makeItem(key, element) {
    return { key: key, element: element };
}
exports.makeItem = makeItem;
var Typeahead = /** @class */ (function (_super) {
    __extends(Typeahead, _super);
    function Typeahead(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { entry: "", value: "" };
        if (props.value) {
            _this.state = _this.getValueFromString(props.value);
        }
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSelect = _this.handleSelect.bind(_this);
        return _this;
    }
    Typeahead.prototype.render = function () {
        var _this = this;
        var filteredItems = this.processItems(this.props.items);
        if (this.state.entry) {
            filteredItems = filteredItems.filter(function (item) { return item.element.toLowerCase().indexOf(_this.state.entry) !== -1; });
        }
        var dropdownItems = filteredItems.map(function (_a) {
            var key = _a.key, element = _a.element;
            return { key: key, element: _this.highlightMatch(element, _this.state.entry) };
        });
        return (react_1.default.createElement(Dropdown_1.Dropdown, { items: dropdownItems, onSelect: this.handleSelect, alignRight: this.props.alignRight, maxHeight: this.props.maxHeight }, function (dropdownProps) { return (react_1.default.createElement(Input_1.Input, __assign({ className: _this.props.inputClassName, label: _this.props.label, value: _this.props.onChange ? _this.props.value : _this.state.value, onChange: _this.handleChange, size: _this.props.size, ref: dropdownProps.toggleRef }, dropdownProps))); }));
    };
    /**
     * `items` may be just strings, or TypeaheadItems. If they are strings,
     * convert to TypeaheadItems and add a key
     */
    Typeahead.prototype.processItems = function (items) {
        var processedItems = items.map(function (item) {
            return typeof item === "string"
                ? { key: item.toLowerCase(), element: item }
                : item;
        });
        // If we support new entries and the value is not empty, add a trailing option for the
        // non-existent value
        if (this.props.allowNewItems &&
            this.state.value &&
            String(this.state.value).trim() !== "") {
            processedItems.push({
                element: "".concat(this.state.value, " ").concat(this.props.newValueLabel || "(New value)"),
                key: String(this.state.value).trim(),
            });
        }
        return processedItems;
    };
    Typeahead.prototype.highlightMatch = function (item, entry) {
        var match = item.toLowerCase().indexOf(entry);
        if (match === -1)
            return item;
        return (react_1.default.createElement("span", null,
            item.substring(0, match),
            react_1.default.createElement("em", { className: "roman font-bold" }, item.substr(match, entry.length)),
            item.substr(match + entry.length)));
    };
    Typeahead.prototype.getValueFromString = function (value) {
        return { value: value, entry: value.toLowerCase() };
    };
    Typeahead.prototype.handleChange = function (event) {
        this.setState(this.getValueFromString(event.target.value));
        if (this.props.onChange)
            this.props.onChange(event);
    };
    // This is false, item could be undefined if we don't have
    // available options
    Typeahead.prototype.handleSelect = function (item) {
        if (item) {
            var selectedItem = this.processItems(this.props.items).find(function (i) { return i.key === item.key; });
            if (selectedItem) {
                this.setState({ value: selectedItem && selectedItem.element });
                var isNewValueItem = this.state.value === item.key;
                if (isNewValueItem) {
                    if (this.props.onSelectNew) {
                        this.props.onSelectNew({
                            key: item.key,
                            element: item.element,
                        });
                    }
                }
                else if (this.props.onSelect) {
                    // Since we set the items, we know the type is really TypeaheadItem, so we can cast safely
                    this.props.onSelect({
                        key: item.key,
                        element: item.element,
                    });
                }
            }
        }
    };
    return Typeahead;
}(react_1.default.Component));
exports.Typeahead = Typeahead;
